/**
 * Odstráni z konca názvu typu zbytočné slovo (zákazník/klient/…),
 * keďže stĺpec už má nadpis „Typ zákazníka“ / „Typ klienta“.
 */
export function customerClientTypeDisplayLabel(label, locale) {
  const raw = String(label || '').trim();
  if (!raw) return raw;
  const rules = {
    sk: /\s+(zákazník|klient)$/i,
    en: /\s+(customer|client)$/i,
    gb: /\s+(customer|client)$/i,
    de: /\s+Kunde$/i,
  };
  const re = rules[locale];
  return re ? raw.replace(re, '').trimEnd() : raw;
}
